import { AT } from '../../../actions/actionTypes';
import { State, DownloadLog } from './model';
import { StateDefault } from './defaults';
import { areEqual } from './utils';
import {
  latestError,
  latestFetch,
  latestSuccess,
  moreError,
  moreFetch,
  moreSuccess,
} from '../../historical/reducer';
import { IHistoricalData } from '../../../models';
import { MessageType } from '../../../core/localization';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const defaultState: State = StateDefault;

export default function (state = defaultState, action: any) {
  switch (action.type) {
    case AT.DIALOG_DOWNLOAD_MORELOGS_FETCH: {
      Logger.info(
        [AT.DIALOG_DOWNLOAD_MORELOGS_FETCH, action],
        LogArea.Redux
      );
      const historical = moreFetch(state.historical);
      return { ...state, historical };
    }

    case AT.DIALOG_DOWNLOAD_MORELOGS_SUCCESS: {
      Logger.info(
        [AT.DIALOG_DOWNLOAD_MORELOGS_SUCCESS, action, state],
        LogArea.Redux
      );
      const data: IHistoricalData<DownloadLog> = action.payload;
      const historical = moreSuccess(state.historical, data, areEqual);
      return { ...state, historical };
    }

    case AT.DIALOG_DOWNLOAD_MORELOGS_ERROR: {
      Logger.info(
        [AT.DIALOG_DOWNLOAD_MORELOGS_ERROR, action, state],
        LogArea.Redux
      );
      const errorMessage: MessageType = action.payload;
      const historical = moreError(state.historical, errorMessage);
      return { ...state, historical };
    }

    case AT.DIALOG_DOWNLOAD_LATESTLOGS_FETCH: {
      Logger.info(
        [AT.DIALOG_DOWNLOAD_LATESTLOGS_FETCH, action],
        LogArea.Redux
      );
      const historical = latestFetch(state.historical);
      return { ...state, historical };
    }

    case AT.DIALOG_DOWNLOAD_LATESTLOGS_SUCCESS: {
      Logger.info(
        [AT.DIALOG_DOWNLOAD_LATESTLOGS_SUCCESS, action, state],
        LogArea.Redux
      );
      const data: IHistoricalData<DownloadLog> = action.payload;
      const historical = latestSuccess(state.historical, data, areEqual);
      return { ...state, historical };
    }

    case AT.DIALOG_DOWNLOAD_LATESTLOGS_ERROR: {
      Logger.info(
        [AT.DIALOG_DOWNLOAD_LATESTLOGS_ERROR, action, state],
        LogArea.Redux
      );
      const errorMessage: MessageType = action.payload;
      const historical = latestError(state.historical, errorMessage);
      return { ...state, historical };
    }

    default: {
      return state;
    }
  }
}
